import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    newWorkspace: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the create workspace button */
            newWorkspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateButton.newWorkspace?c=3um6drb4wackm", defaultMessage: "New Workspace" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
